import moment from "moment";

export const focusInputByName = (name: string) => {
  (
    document.querySelector(`input[name='${name}']`) as HTMLInputElement | null
  )?.focus();
};

export const filterObjectOld = <T>(obj: T, keys: Array<keyof T>) => {
  const result: Pick<T, (typeof keys)[number]> = {} as any;

  keys.forEach((key) => {
    if (obj[key] === undefined) {
      return;
    }
    result[key] = obj[key];
  });

  return result;
};

export const filterObject = (obj: any, keys: any): any => {
  const result: any = {};

  const keyMapping: Record<string, string> = {
    applicatif: "application",
    sous_application: "subApplication",
    t_eau_chaude: "TECS",
    temperature_primaire: "Tp",
    pertes_thermiques_bouclage: "Pboucle",
  };

  Object.keys(keys).forEach((key) => {
    if (typeof keys[key] === "object" && keys[key] !== null) {
      result[key] = filterObject(obj, keys[key]);
    } else if (key in keyMapping && obj[keyMapping[key]] !== undefined) {
      result[key] =
        obj[keyMapping[key]] === "etablissements_scolaires"
          ? "etablissement_scolaires"
          : obj[keyMapping[key]];
    } else {
      result[key] = obj[key] || keys[key];
    }
  });

  return result;
};

export function formatMinutes(minutes: number) {
  const hr: number = Math.floor(minutes / 60),
    min: number = Math.floor(minutes % 60);
  return moment(`${hr}:${min}`, "hhmm").format("HH:mm");
}

export function formatDateTime(isoString?: string | undefined | null) {
  if (!isoString) return "";
  const date = new Date(isoString);
  return date.toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export const roundTo2Decimals = (value?: number) => {
  return value && Math.round((value + Number.EPSILON) * 100) / 100;
};

export const convertToSelect = <T extends { code: string; label: string }>(
  list?: T[]
): (Omit<T, 'code' | 'label'> & { value: string; text: string })[] => {
  return list?.map(({ code, label, ...rest }) => ({
    ...rest,
    value: code,
    text: label,
  })) ?? [];
};
